module.exports = __webpack_public_path__ + "static/media/icon-info.6237db7d.svg";